



























































import {Component, Vue} from 'vue-property-decorator';
import {Getter} from 'vuex-class';

import {mdiSvg} from '@/core';
import NoData from '@/core/components/NoData.vue';

import {Media} from '../interfaces/Media';
import {MediaItem} from '../interfaces/MediaItem';
import MediaItemModal from './MediaItemModal.vue';

@Component({
  components: {
    NoData,
    MediaItemModal,
  },
})
export default class Medias extends Vue {
  @Getter('medias', {namespace: 'media'}) medias!: Media[];

  svgIcons = mdiSvg;

  itemDialog = false;

  currentItem: MediaItem | null = null;

  today = new Date();

  panel = [0];

  formatDate(date: string): string {
    return new Date(date).toLocaleString('fr-fr', {
      day: 'numeric',
      month: 'long',
      year: 'numeric',
    });
  }

  openModal(item: MediaItem): void {
    this.currentItem = item;
    this.itemDialog = true;
  }

  filterItems(media: Media): MediaItem[] {
    const today = this.today.getTime();
    const filtered =
      media.items?.filter((i) => i.images.length && new Date(i.end).getTime() > today) || [];
    // Tri du plus récent au plus ancien
    const sorted = [...filtered].sort((a, b) => {
      const aStart = new Date(a.start).getTime();
      const bStart = new Date(b.start).getTime();
      return bStart - aStart;
    });
    return sorted;
  }
}
